export const MockData: { [key: string]: Mock } = {
    // example mock
    // "session.info": {
    //     response: (params: any) => {
    //         return {
    //             cmd: {
    //                 "success": true,
    //                 "params": {
    //                     sessionId: "aaaaaaaaaaaaa",
    //                     orgId: "bbbbbbbbbbbbb",
    //                     hasSuperAdmin: true,
    //                 }
    //             }
    //         }
    //     }
    // },
}

export const MockedEndpoint = {
    // example mock endpoint
    // "https://toes-engr.devicewise.net/private/campaigns/upload" : (...args) => {
    //     console.log('ex')
    //     return { status: 'ERROR', errorMessage: 'PERMISSION DENY'}},
}

interface Mock {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: (...args: any[]) => unknown
}
